/* Perfect Titanium — knives PDP buy-box engine + live cart AJAX */
(function () {
  var root = document.querySelector('.pt-knives');
  if (!root) return;
  var dataEl = document.getElementById('pt-knives-data');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);

  var fmt = function (cents) {
    var v = (cents / 100);
    var s = v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (DATA.currencySymbol || '$') + s;
  };

  var byId = {};
  DATA.variants.forEach(function (v) { byId[v.id] = v; });

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return document.querySelectorAll(s); };

  // default = Full Set of 4 (first row)
  var firstRow = $('.ptk-row');
  var state = {
    vid: firstRow ? Number(firstRow.dataset.vid) : (DATA.variants[0] && DATA.variants[0].id),
    label: firstRow ? firstRow.querySelector('.bt').textContent : '',
    sharp: false,
    qty: 1
  };

  function selVariant() { return byId[state.vid]; }
  function unitTotal() {
    var v = selVariant(); if (!v) return 0;
    return v.price + (state.sharp && DATA.sharpener && DATA.sharpener.id ? DATA.sharpener.price : 0);
  }
  function grandTotal() { return unitTotal() * state.qty; }

  // ---- genuine bundle saving = sum of the constituent single knives minus the bundle price ----
  //      (a real, non-deceptive comparison — never a phantom compare-at price)
  function partsTotal(row) {
    var parts = (row.dataset.parts || '').split(',').filter(Boolean);
    if (!parts.length) return 0;
    var sum = 0;
    for (var i = 0; i < parts.length; i++) {
      var pv = byId[Number(parts[i])];
      if (!pv) return 0; // if any single is missing, don't show a bogus saving
      sum += pv.price;
    }
    return sum;
  }
  function rowSaving(row, v) {
    var singles = partsTotal(row);
    if (singles && singles > v.price) return { cap: singles, save: singles - v.price };
    if (v.cap && v.cap > v.price) return { cap: v.cap, save: v.cap - v.price };
    return null;
  }

  // ---- fill each row's price + compare ----
  $$('.ptk-row').forEach(function (row) {
    var v = byId[Number(row.dataset.vid)];
    if (!v) return;
    var bp = row.querySelector('.bp'); if (bp) bp.textContent = fmt(v.price);
    var s = rowSaving(row, v);
    var bc = row.querySelector('.bc'); if (bc) bc.textContent = s ? fmt(s.cap) : '';
    var bt = row.querySelector('.btag');
    if (bt) {
      if (s) {
        bt.textContent = 'Save ' + fmt(s.save) + (bt.dataset.best ? ' · Best value' : '');
        bt.style.display = '';
      } else { bt.style.display = 'none'; }
    }
  });

  // ---- swap main gallery image to reflect the selected variant/bundle ----
  function setGalleryImage(src) {
    if (!src) return;
    var img = $('#ptk-gmain'); if (!img) return;
    img.src = src;
    // sync thumb "active" state if this image also exists in the thumb strip
    var matched = false;
    $$('#ptk-thumbs .thumb').forEach(function (t) {
      var isMatch = t.dataset.src === src;
      t.classList.toggle('active', isMatch);
      if (isMatch) matched = true;
    });
    if (!matched) { $$('#ptk-thumbs .thumb').forEach(function (t) { t.classList.remove('active'); }); }
  }

  // ---- row selection ----
  $$('.ptk-row').forEach(function (row) {
    row.onclick = function () {
      $$('.ptk-row').forEach(function (r) { r.classList.remove('on'); });
      row.classList.add('on');
      state.vid = Number(row.dataset.vid);
      state.label = row.querySelector('.bt').textContent;
      setGalleryImage(row.dataset.img);
      update();
    };
  });
  if (firstRow) { firstRow.classList.add('on'); setGalleryImage(firstRow.dataset.img); }

  // ---- sharpener add-on ----
  var addon = $('#ptk-addon');
  if (addon) addon.onclick = function () {
    state.sharp = !state.sharp; addon.classList.toggle('on', state.sharp); update();
  };

  // ---- qty ----
  var qplus = $('#ptk-qplus'), qminus = $('#ptk-qminus'), qinput = $('#ptk-qty');
  if (qplus) qplus.onclick = function () { state.qty = Math.min(state.qty + 1, 9); qinput.value = state.qty; update(); };
  if (qminus) qminus.onclick = function () { state.qty = Math.max(state.qty - 1, 1); qinput.value = state.qty; update(); };

  // ---- gallery thumbs ----
  $$('#ptk-thumbs .thumb').forEach(function (t) {
    t.onclick = function () {
      $$('#ptk-thumbs .thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var img = $('#ptk-gmain'); if (img) img.src = t.dataset.src;
    };
  });

  // ---- tabs ----
  $$('#ptk-tabsnav button').forEach(function (b) {
    b.onclick = function () {
      $$('#ptk-tabsnav button').forEach(function (x) { x.classList.remove('on'); });
      $$('.tabpane').forEach(function (p) { p.classList.remove('on'); });
      b.classList.add('on');
      var pane = root.querySelector('.tabpane[data-t="' + b.dataset.t + '"]');
      if (pane) pane.classList.add('on');
    };
  });

  // ---- faq ----
  $$('#ptk-faq .qa button').forEach(function (btn) {
    btn.onclick = function () {
      var qa = btn.parentElement, ans = qa.querySelector('.ans');
      var open = qa.classList.contains('open');
      qa.classList.toggle('open', !open);
      ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
    };
  });

  // ---- update all prices/totals ----
  function update() {
    var v = selVariant();
    // Headline reflects the full selected configuration (bundle variant + sharpener add-on),
    // mirroring the board PDP where the normal price tracks the whole selection.
    var addon = (state.sharp && DATA.sharpener && DATA.sharpener.id) ? DATA.sharpener.price : 0;
    var priceEl = $('#ptk-price'); if (priceEl && v) priceEl.textContent = fmt(v.price + addon);
    var cmpEl = $('#ptk-compare'), saveEl = $('#ptk-save');
    var selRow = $('.ptk-row.on');
    var s = (v && selRow) ? rowSaving(selRow, v) : (v && v.cap && v.cap > v.price ? { cap: v.cap, save: v.cap - v.price } : null);
    if (s) {
      // Add-on price lifts both the compare figure and the price equally, so the
      // Save pill stays the genuine bundle saving (never a phantom markdown).
      if (cmpEl) { cmpEl.textContent = fmt(s.cap + addon); cmpEl.hidden = false; }
      if (saveEl) { saveEl.textContent = 'Save ' + fmt(s.save); saveEl.hidden = false; }
    } else {
      if (cmpEl) cmpEl.hidden = true;
      if (saveEl) saveEl.hidden = true;
    }
    var total = grandTotal();
    ['#ptk-atctot', '#ptk-atctot2', '#ptk-stot'].forEach(function (sel) {
      var el = $(sel); if (el) el.textContent = fmt(total);
    });
    var q = state.qty > 1 ? ' ×' + state.qty : '';
    var sum = $('#ptk-ssummary'); if (sum) sum.textContent = state.label + q;
  }

  // ---- ADD TO CART (live AJAX) ----
  function buildItems() {
    var items = [{ id: Number(state.vid), quantity: state.qty }];
    if (state.sharp && DATA.sharpener && DATA.sharpener.id) {
      items.push({ id: Number(DATA.sharpener.id), quantity: state.qty });
    }
    return items;
  }

  function notifyDrawer(cart) {
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    try { document.body.dispatchEvent(new CustomEvent('product:added', { bubbles: true })); } catch (e) {}
  }

  function doAdd(btn) {
    var items = buildItems();
    if (!items.length) return;
    var original = btn.innerHTML;
    btn.disabled = true; btn.classList.add('loading');
    btn.innerHTML = '<span>Adding…</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      notifyDrawer(cart);
      btn.classList.remove('loading');
      btn.innerHTML = '<span>Added ✓</span>';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1600);
      // No redirect — UpCart listens to cart events.
    }).catch(function (err) {
      btn.classList.remove('loading');
      btn.innerHTML = '<span>' + (err.message || 'Try again') + '</span>';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 2200);
    });
  }
  ['#ptk-atc', '#ptk-atc2'].forEach(function (sel) {
    var b = $(sel); if (b) b.onclick = function () { doAdd(b); };
  });

  // ---- sticky ATC reveal ----
  var sticky = $('#ptk-sticky'), buybox = $('#ptk-buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buybox);
  }

  // ---- scroll reveal ----
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  update();
})();

/* Thumbs carousel arrows + fade indicators */
(function(){
  var wraps = document.querySelectorAll('.ptk .thumbs-wrap');
  wraps.forEach(function(w){
    var strip = w.querySelector('.thumbs');
    if(!strip) return;
    var prev = w.querySelector('.thumbs-nav.prev');
    var next = w.querySelector('.thumbs-nav.next');
    function update(){
      var maxScroll = strip.scrollWidth - strip.clientWidth - 1;
      w.setAttribute('data-can-prev', strip.scrollLeft > 4 ? '1' : '0');
      w.setAttribute('data-can-next', strip.scrollLeft < maxScroll ? '1' : '0');
      if(prev) prev.hidden = strip.scrollLeft <= 4;
      if(next) next.hidden = strip.scrollLeft >= maxScroll;
    }
    function step(dir){
      var t = strip.querySelector('.thumb');
      var w1 = t ? (t.getBoundingClientRect().width + 8) : 120;
      strip.scrollBy({ left: dir * w1 * 3, behavior: 'smooth' });
    }
    if(prev) prev.addEventListener('click', function(){ step(-1); });
    if(next) next.addEventListener('click', function(){ step(1); });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 50);
  });
})();
